import React, { Fragment, Component } from "react";
import PropTypes from "prop-types";
import {
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  Button,
  Typography,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import { withRouter } from "react-router";
import { ClickableTableCell } from "common/components/Table";
import Resource from "common/components/Resource";
import Panel from "common/components/Panel";
import CreateDialog from "./CreateDialog";
import { userFullname } from "common/utils";

const displayUser = (user) => `${userFullname(user)} (${user.email})`;

class ResourceAdmins extends Component {
  static propTypes = {
    resourceType: PropTypes.string.isRequired,
    resourceId: PropTypes.number.isRequired,
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
  };

  state = {
    dialogOpen: false,
  };

  handleDialogOpen = () => this.setState({ dialogOpen: true });

  handleDialogClose = (cb) => () => this.setState({ dialogOpen: false }, cb);

  render() {
    const { resourceType, resourceId, history } = this.props;

    return (
      <Panel
        title="Administrators"
        action={
          <Button
            variant="contained"
            color="primary"
            onClick={this.handleDialogOpen}
          >
            Add Admin
          </Button>
        }
      >
        <Resource
          name="permissions"
          queryParams={{
            resource: resourceType,
            resource_id: resourceId,
          }}
          error={() => (
            <Typography>Unable to load {resourceType} admins</Typography>
          )}
          render={(permissions, { removeOne, reload }) => (
            <Fragment>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>User</TableCell>
                    <TableCell>Remove Access</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {permissions.length > 0 ? (
                    permissions.map((permission) => (
                      <TableRow key={permission.id}>
                        <ClickableTableCell
                          onClick={() => {
                            history.push(`/users/edit/${permission.user_id}`);
                          }}
                        >
                          <Resource
                            name="users"
                            resourceId={permission.user_id}
                            error={() => (
                              <Typography>Failed to load user data</Typography>
                            )}
                            render={displayUser}
                          />
                        </ClickableTableCell>
                        <TableCell>
                          <IconButton onClick={() => removeOne(permission.id)}>
                            <DeleteIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={2}>
                        No administrators for this {this.props.resourceType}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
              <CreateDialog
                open={this.state.dialogOpen}
                resourceId={this.props.resourceId}
                resourceType={this.props.resourceType}
                onClose={this.handleDialogClose(reload)}
                initialPermissions={permissions}
              />
            </Fragment>
          )}
        />
      </Panel>
    );
  }
}

export default withRouter(ResourceAdmins);
